module.exports = require('react/lib/ReactTestUtils');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-test-utils/index.js
 ** module id = 304
 ** module chunks = 2
 **/